import React from "react";
import { ToastProvider } from "./components/common/Toast";
import { Web3Provider } from "./context/Web3Context";
import { TxProvider } from "./context/TxContext";
import Navbar from "./components/layout/Navbar";
import NetworkGuard from "./components/NetworkGuard";
import DexHome from "./components/DexHome";

export default function App() {
  return (
    <ToastProvider>
      <Web3Provider>
        <TxProvider>
          <div className="app-shell">
            <Navbar />
            <NetworkGuard>
              <DexHome />
            </NetworkGuard>
          </div>
        </TxProvider>
      </Web3Provider>
    </ToastProvider>
  );
}
